import { DashboardType } from './../planner/enums/DashboardType.enum';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MarketAdvertiserContextService } from '../planner/services/market-advertiser-context.service';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {

  private breadcrumb = new BehaviorSubject([]);
  public sharedBreadcrumb = this.breadcrumb.asObservable();

  constructor(
    private router: Router,
    private http: HttpClient,
    private mktAdvCxtService: MarketAdvertiserContextService
  ) { }

  private breadcrumbCommonProps = {
    dropdownEnabled: true,
    dropdownSearchable: true,
    dropdownInfiniteScroll: 'client',
    dropdownMinWidth: 500,
    dropdownMaxResultRows: 10
  };

  updateBreadcrumbForDashboard(dashboardType: DashboardType, resolvedData: any) {
    switch (dashboardType) {
      case DashboardType.MarketDashboard:
        this.breadcrumb.next([]);
        break;
      case DashboardType.AdvertiserDashboard:
        this.prepareBreadcrumb(resolvedData.marketId);
        break;
      case DashboardType.PlannerDashboard:
        this.prepareBreadcrumb(resolvedData.marketId, resolvedData.advertiserId);
        break;
    }
  }

  updateBreadcrumb(breadcrumb: Array<any>) {
    this.breadcrumb.next(breadcrumb);
  }

  prepareBreadcrumb(marketId: string, advertiserId?: string) {
    let promiseList = [this.getMarketData(marketId)];
    if (advertiserId) {
      promiseList.push(this.getAdvertiserData(advertiserId, marketId));
    }
    Promise.all(promiseList).then((values) => {
      this.breadcrumb.next(values);
    });
  }

  async getMarketData(marketId: string) {
    let marketData = Object.assign({
      title: '',
      label: 'Market',
      link: `#/market-dashboard/${marketId}/advertiser-list`,
      dropdownItems: [],
    }, this.breadcrumbCommonProps);

    let markets = await this.mktAdvCxtService.getFullList('MARKET').then(
      (response: any[]) => {
        // response will be the form of [{'marketId' : 'MarketName'}] : [{'123' : 'Paypal Test'}]
        return response;
      }
    );
    let marketKey: string, marketName: string;
    for (let i = 0; i < markets.length; i++) {
      marketKey = Object.keys(markets[i])[0];
      marketName = markets[i][marketKey];
      if (marketKey == marketId) {
        marketData.title = marketName;
      }
      marketData.dropdownItems.push({
        label: marketName + ' (' + marketKey + ')',
        marketId: marketKey,
        onClick: this.handleOnMarketSelectRef
      });
    }
    return marketData;
  }

  async getAdvertiserData(advertiserId: string, marketId: string) {
    let advertiserData = Object.assign({
      title: '',
      label: 'Advertiser',
      link: `#/advertiser-dashboard/${advertiserId}/planner-list?marketId=${marketId}`,
      dropdownItems: [],
    }, this.breadcrumbCommonProps);

    let advertiser = await this.mktAdvCxtService.getFullList('ADVERTISER', marketId).then(
      (response: any[]) => {
        // response will be the form of [{'advertiserId' : 'advertiserName'}] : [{'123' : 'Test Advertiser'}]
        return response;
      }
    );
    let advKey: string,
      advName: string;
    for (let i = 0; i < advertiser.length; i++) {
      advKey = Object.keys(advertiser[i])[0];
      advName = advertiser[i][advKey];
      if (advKey == advertiserId) {
        advertiserData.title = advName;
      }
      advertiserData.dropdownItems.push({
        label: advName + ' (' + advKey + ')',
        marketId: marketId,
        advertiserId: advKey,
        onClick: this.handleOnAdvertiserSelectRef
      });
    }
    return advertiserData;
  }

  handleOnMarketSelectRef = this.handleOnMarketSelect.bind(this);
  handleOnAdvertiserSelectRef = this.handleOnAdvertiserSelect.bind(this);

  handleOnMarketSelect(item) {
    this.router.navigate([DashboardType.MarketDashboard, item.props.marketId, 'advertiser-list']);
  }

  handleOnAdvertiserSelect(item) {
    this.router.navigate([DashboardType.AdvertiserDashboard, item.props.advertiserId, 'planner-list'], { queryParams: { marketId: item.props.marketId } });
  }

}
